import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		content: {
			marginBottom: 2,
		},
		[theme.breakpoints.down('xs')]: {
			image: {
				maxHeight: theme.spacing(16),
				height: 'auto',
			},
		},
	}),
	{ name: 'CallToAction-Cta4' },
)

export default useStyles
